module.exports = "pegasus/assets/blocks/column-lp0-basic.png";